import React from 'react';
import styled from 'styled-components';

import { Divider } from 'components';

import type { GetSimpleListingsByIdsDTO } from '@/app-package';

import { ContactDrawerTeam, ContactDrawerType } from '../../../types';

import DetailsSkeleton from '../Skeleton';
import TeamContactDetails from './TeamContactDetails';
import TeamMemberDetails from './TeamMemberDetails';
import TeamListingDetails from './TeamListingDetails';
import {
  DetailsContainer,
  HeaderContainer,
  HeaderText,
  ContentContainer,
  ListContainer,
} from '../common';

interface TeamDetailsProps {
  isLoading: boolean;
  teamContact: ContactDrawerTeam;
  teamListings: GetSimpleListingsByIdsDTO['listings'];
  goToContact: (type: ContactDrawerType, contactId: string) => void;
  goToListing: (listingId: string) => void;
}

const TeamDetails: React.FC<TeamDetailsProps> = ({
  isLoading,
  teamContact,
  teamListings,
  goToContact,
  goToListing,
}) => {
  if (isLoading || !teamContact) {
    return DetailsSkeleton;
  }

  return (
    <DetailsContainer>
      <HeaderContainer>
        <HeaderText>Contact</HeaderText>
      </HeaderContainer>
      <Divider />
      <StyledContent>
        <ContentContainer>
          <TeamContactDetails teamContact={teamContact} />
        </ContentContainer>
      </StyledContent>
      {teamContact.users.length > 0 && (
        <ListContainer data-cy="contact-details-users-container">
          <HeaderContainer>
            <HeaderText>Members</HeaderText>
          </HeaderContainer>
          <Divider />
          <TeamMemberDetails
            teamContact={teamContact}
            goToContact={goToContact}
          />
        </ListContainer>
      )}
      {teamListings.length ? (
        <ListContainer data-cy="contact-details-listings-container">
          <HeaderContainer>
            <HeaderText>Listings</HeaderText>
          </HeaderContainer>
          <Divider />
          <TeamListingDetails
            teamListings={teamListings}
            goToListing={goToListing}
          />
        </ListContainer>
      ) : null}
    </DetailsContainer>
  );
};

export default TeamDetails;

const StyledContent = styled.div`
  max-height: 30vh;
  overflow-y: auto;
`;
